export default {"src":"/_next/static/media/play-solid.59a2967f.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};